export const Notifications = 'notifications';

export const NotificationsView = `/${Notifications}`;
